// Pure helpers extracted from use-clinics-filter.hook.tsx.
// Generic over T extends { id: number } so these can be tested without the
// full Clinic type (which pulls in constants/clinics → potential import.meta chain).

export function computeSelectedClinics<T extends { id: number }>(params: {
  isSchedule21Enabled: boolean;
  schedulingV2FeatureEnabled: boolean;
  showCurrentClinicEventsOnly: boolean;
  currentClinic: T | null | undefined;
  clinics: T[];
  defaultValues: number[] | null;
}): T[] {
  const {
    isSchedule21Enabled,
    schedulingV2FeatureEnabled,
    showCurrentClinicEventsOnly,
    currentClinic,
    clinics,
    defaultValues
  } = params;

  if (!clinics?.length) return [];

  if (isSchedule21Enabled) {
    return showCurrentClinicEventsOnly
      ? ([currentClinic].filter(Boolean) as T[])
      : clinics;
  }

  if (schedulingV2FeatureEnabled) {
    return clinics;
  }

  const validIds = (defaultValues ?? []).filter((id) =>
    clinics.some((c) => c.id === id)
  );
  return validIds
    .map((id) => clinics.find((c) => c.id === id))
    .filter(Boolean) as T[];
}

export function computeEffectiveClinicSelection<T extends { id: number }>(params: {
  disableStorage?: boolean;
  isSchedule21Enabled: boolean;
  showCurrentClinicEventsOnly: boolean;
  schedulingV2FeatureEnabled: boolean;
  currentClinicSelectedFromStorage: boolean;
  currentClinic: T | null | undefined;
  selected: T[];
}): (T | null | undefined)[] {
  const {
    disableStorage,
    isSchedule21Enabled,
    showCurrentClinicEventsOnly,
    schedulingV2FeatureEnabled,
    currentClinicSelectedFromStorage,
    currentClinic,
    selected
  } = params;

  if (disableStorage) return selected;

  if (isSchedule21Enabled) {
    return showCurrentClinicEventsOnly ? [currentClinic] : selected;
  }

  if (schedulingV2FeatureEnabled) {
    return currentClinicSelectedFromStorage ? [currentClinic] : selected;
  }

  return selected;
}
